<template>
	<div class="fluid w-100">

    <div class="courses_section">
      <template v-if="educationReqs.length > 0">
        <div class="inst_list_container">
          <template v-for="(education, i) in educationReqs">
            <div>
              <div class="row sec_hd" role="heading" tabindex="0">
                <div class="col-12 hd_txt">
                  <div>{{education.title}}</div>
                </div>
              </div>
              <div class="row sec_content">
                <div class="col-12 sec_txt">
                  <div>{{education.description}}</div>
                </div>
              </div>
              <div class="row sec_content">
                <div class="col-12 sec_txt">
                  <b-collapse visible :id="'institution-' + education.uuid">
                    <div class="course_list_container">
                      <span v-for="req in education.children" :key="req.originUuid">
                        <div class="row course_row">
													<div class="float-left text-center mr-3" style="width: 80px;">
														<div style="height: 50px; border-radius: 8px;">
															<div style="line-height: 50px; color: #fff;">
																<div style="height: 30px;" class="ico-job float-left" v-if="(req.entityType === 'JOB')">
	                              </div>
	                              <div style="height: 30px;" class="ico-program float-left" v-if="(req.entityType === 'PROGRAM')">
	                              </div>
	                              <div style="height: 30px;" class="ico-letter float-left" v-if="(req.entityType === 'LETTER')">
	                              </div>
	                              <div style="height: 30px;" class="ico-catalog float-left" v-if="(req.entityType === 'CATALOG')">
	                              </div>
															</div>
														</div>
													</div>
                          <div class="title col-6">
                            <div>
                              <div>
                                <div class="col_title" style="cursor: default !important; color: #5f5f5f !important;">
                                  {{req.title}}
                                </div>
                              </div>
                              <div>
                                <div class="description">
                                  {{req.description}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-2" v-if="req.courseGrade">
                            <div class="txt_container">
                              <span>
                                performance > {{req.courseGrade}}
                              </span>
                            </div>
                          </div>

                        </div>
                      </span>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  
  export default {
    name: 'program-education',
    props: ['pathwayId'],
    data () {
      return {
        educationReqs: []
      }
    },
    async mounted () {
      this.educationReqs = await this.loadProgramEducation(this.pathwayId)
    },
    methods: {
      ...mapActions([
        'loadProgramEducation'
      ])
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramEducation.vue